<form [formGroup]="form">
  <kodit-field fieldLabel="Magacini">
    <kodit-magacini-multiselect
      formCtrlId="magacini"
      [magaciniFormArray]="form.controls.magacini"
      (selectedMagacini)="selectedMagacini($event)"
    ></kodit-magacini-multiselect>
  </kodit-field>
</form>
